var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg82NotCovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84659",
    "data-name": "Group 84659",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.918,
    height: 80.235,
    viewBox: "0 0 96.918 80.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84656",
    "data-name": "Group 84656",
    transform: "translate(46.265 28.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240145",
    "data-name": "Path 240145",
    d: "M259.73,10.9a12.792,12.792,0,1,1-12.791,12.791A12.791,12.791,0,0,1,259.73,10.9",
    transform: "translate(-234.406 -10.897)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240146",
    "data-name": "Path 240146",
    d: "M280.936,19.426a17.012,17.012,0,0,1-26.4,0,14.549,14.549,0,0,0-12.127,14.329V47.367h8.8V35.614a1.881,1.881,0,0,1,3.763,0V47.367H280.5V35.614a1.88,1.88,0,0,1,3.76,0V47.367h8.8V33.755a14.549,14.549,0,0,0-12.127-14.329",
    transform: "translate(-242.409 4.171)",
    fill: "#8e8e8e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84657",
    "data-name": "Group 84657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240147",
    "data-name": "Path 240147",
    d: "M247.015,9.8a1.864,1.864,0,0,0,.91-.238l6.7-3.721A1.88,1.88,0,0,0,252.8,2.556l-6.7,3.721a1.881,1.881,0,0,0,.916,3.525",
    transform: "translate(-191.332 2.646)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240148",
    "data-name": "Path 240148",
    d: "M246.1,11.085l6.7,3.724a1.88,1.88,0,1,0,1.826-3.287l-6.7-3.724a1.88,1.88,0,1,0-1.826,3.287",
    transform: "translate(-191.333 11.907)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240149",
    "data-name": "Path 240149",
    d: "M247.129,5.613a1.88,1.88,0,1,0,0,3.76h7.7a1.88,1.88,0,1,0,0-3.76Z",
    transform: "translate(-191.128 8.464)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240150",
    "data-name": "Path 240150",
    d: "M262.9,34.268H252.184A1.464,1.464,0,0,1,250.72,32.8V20.243a1.464,1.464,0,0,1,1.464-1.464h22a2.945,2.945,0,0,0,2.905-3.439,3.054,3.054,0,0,0-3.063-2.451H248.831V5.522a5,5,0,0,0-5-5h-2.623V7.06a4.912,4.912,0,0,1-4.822,5.022,4.946,4.946,0,0,0-3.533,1.358l-2.5,2.377h-4.665v22.4h8.751l6.1,1.948h22.206A3.057,3.057,0,0,0,265.8,37.71a2.947,2.947,0,0,0-2.905-3.442",
    transform: "translate(-225.687 -0.525)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240151",
    "data-name": "Path 240151",
    d: "M248.745,7.543h-10.7a2.947,2.947,0,1,0,0,5.893h10.7a2.947,2.947,0,0,0,0-5.893",
    transform: "translate(-209.053 11.874)",
    fill: "#ffb164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240152",
    "data-name": "Path 240152",
    d: "M248.745,10.132h-10.7a2.947,2.947,0,1,0,0,5.893h10.7a2.947,2.947,0,0,0,0-5.893",
    transform: "translate(-209.053 16.448)",
    fill: "#ffb164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg82NotCovered);
export default __webpack_public_path__ + "static/media/8.2_Not_Covered.1edc78fd7574f781b181263fff1f88d4.svg";
export { ForwardRef as ReactComponent };